import { ApiWrapper } from "../types/main";
import { apiCall, http } from "./http";

export const REWORK_AUTH_STATUS_TIMEOUT_MS = 5_000;

export async function createApp({
    crmConnectorId,
    connectorId,
    data,
}: {
    crmConnectorId: string
    connectorId: string
    data: any,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/create`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: {crmConnectorId, connectorId, data },
        }),
    );
    return res;
}
export async function updateApp({
    connectorId,
    data,
}: {
    connectorId: string
    data: any,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/update`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, data },
        }),
    );
    return res;
}
export async function getApp({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function getAppQr({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function getAppQrWApi({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/qrWApiWhatsapp?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function getNoAuthWaWapiQr({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/wa/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}
export async function getAuthStatus({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/authStatus?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function connectWaInstance({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/connectWaInstance
`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}
export async function createWhatsAppWApiInstance({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/createWhatsAppWApiInstance
`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}
export async function checkWaInstanceAlive({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<{ alive: boolean } | null>> {
    const url = `networkFixer/app/checkWaInstanceAlive?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}
export async function checkWhatsAppWApiInstanceAlive({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<{ alive: boolean } | null>> {
    const url = `networkFixer/app/checkWhatsAppWApiInstanceAlive?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}

export async function unAuthInstance({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<{ alive: boolean } | null>> {
    const url = `networkFixer/app/unAuthInstance?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}

export async function createInstanceTg({ connectorId }) {
    const url = `networkFixer/app/createTgWApiInstance
`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}

export async function sendCodeTg({ connectorId, phone }) {
    const url = `networkFixer/app/sendTgWApiInstance
`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, phone },
        }),
    );
    return res;
}

export async function inputCodeTg({ connectorId, code }) {
    const url = `networkFixer/app/inputTgWApiInstance
`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, code },
        }),
    );
    return res;
}
export async function checkPhoneBeforeActivatingControl({
    phone,
    connectorId,
}: {
    phone: string
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/isConnectPhone?phone=${phone}&connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}
export async function controlPhoneToggle({ connectorId, phone }) {
    const url = `networkFixer/connectPhone?phone=${phone}`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}
export async function controlPhoneList({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/connectedPhone?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}

export async function getNoAuthToken({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/noAuthToken?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}

export async function getNoAuthQr({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}
export async function getAdditionalServices({
    projectId,
}: {
    projectId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/additionalServices?projectId=${projectId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function editAdditionalServices({
    projectId,
    services,
}: {
    projectId: string
    services: Array<{ id?: number | string; name?: string; type: "add" | "remove" | "firstRequest" }>,
}) {
    const url = `networkFixer/additionalServices?projectId=${projectId}`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { services },
        }),
    );
    return res;
}
export async function createInstanceGreenApiMax({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/createInstanceGreenApiMax`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}
export async function getAuthorizationCodeGreenApiMax({
    connectorId,
    phone,
}: {
    connectorId: string
    phone: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/startAuthorizationGreenApiMax`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, phone },
        }),
    );
    return res;
}
export async function sendAuthorizationCodeGreenApiMax({
    connectorId,
    code,
}: {
    connectorId: string
    code: string,
}) {
    const url = `networkFixer/app/sendAuthorizationCodeGreenApiMax`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, code },
        }),
    );
    return res;
}
export async function createDhTgInstance({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/createDhTgInstance
`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}
export async function getDhTgInstanceQrCode({ instanceId }: { instanceId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/getDhTgInstanceQrCode?instanceId=${instanceId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function getDhTgInstanceStatus({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<{ status: string, error: boolean } | null>> {
    const url = `networkFixer/app/getDhTgInstanceStatus?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}
export async function getMaxQr({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkfixer/app/max/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function getNoAuthMaxQr({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/max/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}
export async function getWapiTgQr({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/app/tg/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function getNoAuthTgWapiQr({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/tg/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}
// ==================== Channel API ====================
export async function createChannel({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/create
`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}
export async function getAppQrRework({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/waBasis/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}

export async function getAppQrWApiRework({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/waApi/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function getNoAuthWApiQrRework({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/wa/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}

export async function createInstanceTgRework({ connectorId }) {
    const url = `networkFixer/channel/telegram/create
`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}

export async function sendCodeTgRework({ connectorId, phone }) {
    const url = `networkFixer/channel/telegram/sendCode
`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, phone },
        }),
    );
    return res;
}

export async function inputCodeTgRework({ connectorId, code }) {
    const url = `networkFixer/channel/telegram/inputCode
`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, code },
        }),
    );
    return res;
}

export async function createInstanceGreenApiMaxRework({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/max/create`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}
export async function getAuthorizationCodeGreenApiMaxRework({
    connectorId,
    phone,
}: {
    connectorId: string
    phone: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/max/startAuthorization`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, phone },
        }),
    );
    return res;
}
export async function sendAuthorizationCodeGreenApiMaxRework({
    connectorId,
    code,
}: {
    connectorId: string
    code: string,
}) {
    const url = `networkFixer/channel/max/sendAuthorizationCode`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, code },
        }),
    );
    return res;
}

export async function getMaxQrRework({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/max/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function getAuthStatusRework({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/authStatus?connectorId=${connectorId}`;
    const res = apiCall<any>(() =>
        http.get(url.toString(), { timeout: REWORK_AUTH_STATUS_TIMEOUT_MS }),
    );
    return res;
}

export async function unAuthInstanceRework({
    connectorId,
}: {
    connectorId: string
    phone: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/unAuth`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId},
        }),
    );
    return res;
}

export async function getChannelPhone({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/phone?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
// SMS-v2: номер SIM подтверждает клиент — из карты его не достать.
// Пишется только для каналов sms-gate (проверка на бэке).
export async function setChannelPhone({
    connectorId,
    phone,
}: {
    connectorId: string,
    phone: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/phone`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, phone },
        }),
    );
    return res;
}

// SMS-v2: выбор SIM-карты, с которой канал отправляет.
// Список симок приходит в статусе (их знает телефон), выбор хранится в канале.
export async function setChannelSim({
    connectorId,
    simNumber,
}: {
    connectorId: string,
    simNumber: number,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/sim`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, simNumber },
        }),
    );
    return res;
}

export async function getNoAuthWaBasisQrRework({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}
export async function getNoAuthMaxBasisQrRework({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/max/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}

export async function getWaDhChannelQr({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/wa-dh/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}

export async function getDhMaxChannelQr({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/max-dh/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}

/**
 * Переезд на наш провайдер: QR нашего инстанса для канала, который пока работает
 * через стороннего. Ответ: { status: 'generating' | 'ready' | 'authorized' |
 * 'already_on_target' | 'error', qr?, qrFormat?: 'raw' | 'png', message? }.
 * Ошибки — { error: code }: migration_disabled, provider_not_authorized и др.
 */
export async function getDhMigrationQr({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/dh-migration/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}

/**
 * Тот же переезд, но по расшаренной ссылке: авторизации нет, канал опознаём по токену.
 * Нужна странице /qr, иначе у переезжающего канала поделиться QR нечем.
 */
export async function getNoAuthDhMigrationQr({ qrToken }: { qrToken: string }): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/dh-migration/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}

/**
 * Каналы проекта, которым можно предложить переезд на наш провайдер. Ответ —
 * основание показать модалку переподключения: { show, channels: [...] }.
 * Пустой список значит «не показывать».
 */
export async function getDhMigrationPrompt({
    projectId,
}: {
    projectId: string
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/project/dh-migration/prompt?projectId=${projectId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}

export async function deauthWaDhChannel({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/wa-dh/deauth`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}

export async function deauthDhMaxChannel({
    connectorId,
}: {
    connectorId: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/max-dh/deauth`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId },
        }),
    );
    return res;
}

export async function getNoAuthWaDhQrRework({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/wa-dh/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}

export async function getNoAuthDhMaxQrRework({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/max-dh/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}

export async function connectMaxBusiness({
    connectorId,
    token,
}: {
    connectorId: string
    token: string
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/maxBusiness`
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, token },
        })
    )
    return res
}

export async function getMaxBusinessStatus({
    connectorId,
}: {
    connectorId: string
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/maxBusiness?connectorId=${connectorId}`
    const res = apiCall<any>(() => http.get(url.toString(), {}))
    return res
}

export async function connectSmsGate({
    connectorId,
    username,
    password,
    deviceId,
    phone,
}: {
    connectorId: string
    username: string
    password: string
    deviceId: string
    phone: string
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/smsGate`
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, username, password, deviceId, phone },
        })
    )
    return res
}

export async function getSmsGateStatus({
    connectorId,
}: {
    connectorId: string
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/smsGate?connectorId=${connectorId}`
    const res = apiCall<any>(() => http.get(url.toString(), {}))
    return res
}

// SMS-v2 (QR-онбординг): payload для QR по коннектору { url, token }.
// Приложение SMS DH сканит его и подключается «из коробки».
export async function getSmsGateQr({
    connectorId,
}: {
    connectorId: string
}): Promise<ApiWrapper<{ url: string; token: string } | null>> {
    const url = `noAuth/channel/smsGate/qr?connectorId=${connectorId}`
    const res = apiCall<{ url: string; token: string }>(() =>
        http.get(url.toString(), {})
    )
    return res
}

export async function getMaxBusinessBotTelegramLink({
    connectorId,
}: {
    connectorId: string
}): Promise<ApiWrapper<string | null>> {
    const url = `noAuth/channel/maxBusiness/botLink?connectorId=${encodeURIComponent(connectorId)}`
    const res = await apiCall<{ error?: boolean; data?: string | null } | string | null>(() =>
        http.get(url.toString(), {})
    )
    if (res.error) {
        return { data: null, error: res.error }
    }
    const body = res.data
    if (body == null) {
        return { data: null, error: null }
    }
    if (typeof body === 'string') {
        return { data: body.trim() || null, error: null }
    }
    if (body.error) {
        return { data: null, error: body }
    }
    const link = body.data != null ? String(body.data).trim() : ''
    return { data: link || null, error: null }
}

export async function getTgWaQrRework({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/tg/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function getNoAuthTgWaQrRework({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/tg/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}

export async function getTgDhChannelQr({ connectorId }: { connectorId: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/tg-dh/qr?connectorId=${connectorId}`;
    const res = apiCall<any>(() => http.get(url.toString()));
    return res;
}
export async function sendCodeTgDhChannel({ connectorId, phone }: { connectorId: string; phone: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/tg-dh/send-code`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, phone },
        }),
    );
    return res;
}
export async function signInTgDhChannel({ connectorId, code }: { connectorId: string; code: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/tg-dh/sign-in`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, code },
        }),
    );
    return res;
}
export async function passwordTgDhChannel({ connectorId, password }: { connectorId: string; password: string }): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/channel/tg-dh/password`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { connectorId, password },
        }),
    );
    return res;
}
export async function getNoAuthTgDhQrRework({
    qrToken,
}: {
    qrToken: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `noAuth/channel/tg-dh/qr?qrToken=${qrToken}`;
    const res = apiCall<any>(() => http.get(url.toString(), {}));
    return res;
}

// ==================== Слоты каналов ====================
export async function getSlots({
    projectId,
}: {
    projectId: string
}): Promise<ApiWrapper<any | null>> {
    const url = `channelSlots/list?projectId=${projectId}`
    const res = apiCall<any>(() => http.get(url.toString(), {}))
    return res
}
export async function getPendingSlots({
    projectId,
}: {
    projectId: string
}): Promise<ApiWrapper<any | null>> {
    const url = `channelSlots/pendingPaymentPayloadsForChannelSlot?projectId=${projectId}`
    const res = apiCall<any>(() => http.get(url.toString(), {}))
    return res
}
export async function unchainSlot({
    subscriptionId,
}: {
    subscriptionId: number
}): Promise<ApiWrapper<any | null>> {
    const url = `channelSlots/unchainSlot?subscriptionId=${subscriptionId}`
    const res = apiCall<any>(() => http.get(url.toString(), {}))
    return res
}

export async function setSlot({
    slotId,
    channelConnectorId
}: {
    slotId: string
    channelConnectorId: string
}): Promise<ApiWrapper<any | null>> {
    const url = `channelSlots/addChannel`
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { slotId, channelConnectorId},
        })
    )
    return res
}

// ==================== Cascade API ====================

export interface Cascade {
    id: number;
    projectId: string;
    name: string;
    sendType: "failover" | "broadcast" | null;
    cascadeType: "mailings" | "notifications" | "crmMessages" | "custom" | null;
    maxSendDuration: number | null;
    status: string | null;
    channels: CascadeChannel[];
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
}

export interface CascadeChannel {
    id: number;
    cascadeId: number;
    channelId: number;
    priority: number;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
}

/**
 * Получить все каскады проекта
 */
export async function getCascadesByProject(projectId: string): Promise<ApiWrapper<Cascade[] | null>> {
    const url = `networkFixer/cascade/project/${projectId}`;
    const res = apiCall<Cascade[]>(() => http.get(url.toString()));
    return res;
}

/**
 * Создать каскад
 * POST /networkFixer/cascade
 */
export async function createCascade({
    projectId,
    name,
    cascadeType,
    sendType = "failover",
    maxSendDuration = 3600,
    status,
}: {
    projectId: string
    name: string
    cascadeType?: "mailings" | "notifications" | "crmMessages" | "custom" | null
    sendType?: "failover" | "broadcast" | null
    maxSendDuration?: number | null
    status?: string | null
}): Promise<ApiWrapper<Cascade | null>> {
    const url = `networkFixer/cascade`;
    const body: Record<string, unknown> = { projectId, name, sendType };
    if (cascadeType !== undefined) {
        body.cascadeType = cascadeType;
    }
    if (maxSendDuration !== undefined) {
        body.maxSendDuration = maxSendDuration;
    }
    if (status !== undefined) {
        body.status = status;
    }
    const res = apiCall<Cascade>(() =>
        http.post(url.toString(), {
            json: body,
        }),
    );
    return res;
}

/**
 * Создать дефолтные каскады (mailings + notifications + crmMessages)
 * POST /networkFixer/cascade/default/:projectId
 */
export async function cascadeDefaultCreate(projectId: string): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/cascade/default/${projectId}`;
    const res = apiCall<any>(() => http.post(url.toString()));
    return res;
}

/**
 * Создать только mailings дефолтный каскад
 * POST /networkFixer/cascade/default/:projectId/mailings
 */
export async function cascadeDefaultMailingsCreate(projectId: string): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/cascade/default/${projectId}/mailings`;
    const res = apiCall<any>(() => http.post(url.toString()));
    return res;
}

const DEFAULT_CASCADE_NAME = 'Каскад 2';

/**
 * Создать кастомный каскад «Администраторы» (идемпотентно)
 */
export async function cascadeDefaultAdministratorsCreate(projectId: string): Promise<ApiWrapper<Cascade | null>> {
    const { data: cascades, error: fetchError } = await getCascadesByProject(projectId);
    if (fetchError) {
        return { data: null, error: fetchError };
    }
    const existing = (cascades || []).find(
        cascade => cascade?.cascadeType === 'custom' && cascade?.name === DEFAULT_CASCADE_NAME,
    );
    if (existing) {
        return { data: existing, error: null };
    }
    return createCascade({
        projectId,
        name: DEFAULT_CASCADE_NAME,
        cascadeType: 'custom',
        sendType: 'failover',
        status: 'active',
    });
}

/**
 * Обновить таймзону проекта (Firebase)
 * POST /networkFixer/cascade/project/:projectId/timezone
 */
export async function updateProjectTimezone({
    projectId,
    timezone,
}: {
    projectId: string
    timezone: string,
}): Promise<ApiWrapper<any | null>> {
    const url = `networkFixer/cascade/project/${projectId}/timezone`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { timezone },
        }),
    );
    return res;
}

/**
 * Получить каскад по ID
 */
export async function getCascadeById(cascadeId: number | string): Promise<ApiWrapper<Cascade | null>> {
    const url = `networkFixer/cascade/${cascadeId}`;
    const res = apiCall<Cascade>(() => http.get(url.toString()));
    return res;
}

/**
 * Обновить каскад
 */
export async function updateCascade({
    cascadeId,
    name,
    sendType,
    cascadeType,
    maxSendDuration,
    status,
}: {
    cascadeId: number | string
    name?: string
    sendType?: "failover" | "broadcast" | null
    cascadeType?: "mailings" | "notifications" | "crmMessages" | "custom" | null
    maxSendDuration?: number | null
    status?: string | null,
}): Promise<ApiWrapper<Cascade | null>> {
    const url = `networkFixer/cascade/${cascadeId}`;
    const body: any = {};
    if (name !== undefined) { body.name = name; }
    if (sendType !== undefined) { body.sendType = sendType; }
    if (cascadeType !== undefined) { body.cascadeType = cascadeType; }
    if (maxSendDuration !== undefined) { body.maxSendDuration = maxSendDuration; }
    if (status !== undefined) { body.status = status; }

    const res = apiCall<Cascade>(() =>
        http.patch(url.toString(), {
            json: body,
        }),
    );
    return res;
}

/**
 * Удалить каскад
 */
export async function deleteCascade(cascadeId: number | string): Promise<ApiWrapper<{ success: boolean } | null>> {
    const url = `networkFixer/cascade/${cascadeId}`;
    const res = apiCall<{ success: boolean }>(() => http.delete(url.toString()));
    return res;
}

/**
 * Получить каналы каскада
 */
export async function getCascadeChannels(cascadeId: number | string): Promise<ApiWrapper<CascadeChannel[] | null>> {
    const url = `networkFixer/cascade/${cascadeId}/channels`;
    const res = apiCall<CascadeChannel[]>(() => http.get(url.toString()));
    return res;
}

/**
 * Обновить приоритет канала в каскаде
 */
export async function updateCascadeChannelPriority({
    cascadeId,
    channelId,
    priority,
}: {
    cascadeId: number | string
    channelId: number | string
    priority: number,
}): Promise<ApiWrapper<CascadeChannel | null>> {
    const url = `networkFixer/cascade/${cascadeId}/channels/${channelId}/priority`;
    const res = apiCall<CascadeChannel>(() =>
        http.patch(url.toString(), {
            json: { priority },
        }),
    );
    return res;
}

/**
 * Массовое обновление приоритетов каналов в каскаде
 */
export async function updateCascadeChannelsPriorities({
    cascadeId,
    channels,
}: {
    cascadeId: number | string
    channels: Array<{ channelId: number | string; priority: number }>,
}): Promise<ApiWrapper<CascadeChannel[] | null>> {
    const url = `networkFixer/cascade/${cascadeId}/channels/priorities`;
    const res = apiCall<CascadeChannel[]>(() =>
        http.patch(url.toString(), {
            json: { channels },
        }),
    );
    return res;
}

/**
 * Удалить канал из каскада
 */
export async function deleteCascadeChannel(cascadeChannelId: number | string): Promise<ApiWrapper<{ success: boolean } | null>> {
    const url = `networkFixer/cascade/channels/${cascadeChannelId}`;
    const res = apiCall<{ success: boolean }>(() => http.delete(url.toString()));
    return res;
}